import { useEffect, useState } from "react";
import styles from "./TabBar.module.css";
import TabBarItem from "./TabBarItem";

export class TabBarElement {
  id: number;
  title: string;
  selected: boolean;

  constructor(id: number, title: string, selected: boolean) {
    this.id = id;
    this.title = title;
    this.selected = selected;
  }
}

interface TabBarProps {
  items: TabBarElement[];
  onChangeSelectedItem: (id: number) => void;
}

export default function TabBar(props: TabBarProps) {
  function handleOnClickItem(id: number) {
    const foundItem = props.items.find((item) => item.id === id);
    if (foundItem) {
      props.onChangeSelectedItem(id);
    }
  }

  return (
    <>
      <div className={styles.container}>
        <div className={styles.contentContainer}>
          {props.items.map((item) => (
            <TabBarItem
              key={item.id}
              id={item.id}
              title={item.title}
              selected={item.selected}
              // selected={selectedItem === item.id}
              handleClick={handleOnClickItem}
            ></TabBarItem>
          ))}
        </div>
        <div className={styles.underLine} />
      </div>
    </>
  );
}
